import { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
  gap?: string;
}

export const ConnectContentWrapper = ({ children, gap = '30px' }: Props) => (
  <Flex flexDirection="column" gap={gap} w="100%" maxW="950px" marginInline="auto">
    {children}
  </Flex>
);
